var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.classButton + 'svg-edit-container noMargin',on:{"click":function($event){return _vm.action()}}},[_c('span',{staticClass:"tooltip"},[_vm._v(_vm._s(_vm.tooltipText))]),_c('img',{attrs:{"src":_vm.bgColor,"width":"18","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }